var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body py-2 d-flex align-items-center justify-content-center",staticStyle:{"min-height":"120px"}},[_c('prismic-image',{attrs:{"img":_vm.image,"w":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }